import api from "./api";

const AddFiles = "files/add";
const CaseFiles = "files/getCaseFiles";
const DeleteFile = "files/delete";

const add = (files) => api.post(AddFiles, files);
const del = (id) => api.delete(DeleteFile, { id });
const getCaseFiles = (caseNumber) =>
  api.get(`${CaseFiles}?caseNumber=${caseNumber}`);

const filesServices = {
  add,
  getCaseFiles,
  del,
};
export default filesServices;
